var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{attrs:{"disable-sort":"","headers":_vm.headers,"items":_vm.wiringsItems,"items-per-page":10}})
}
var staticRenderFns = []

export { render, staticRenderFns }